import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useLoggedInUser } from '~/context'
import { fetchFeatureFlag } from '~/services'

export type FeatureFlagType = 'OncologyView' | 'InteractiveAI' | 'BreastCancerPRS'

interface FeatureFlagProps {
  flag: FeatureFlagType
  fallback?: JSX.Element
  children: JSX.Element
}

export const FeatureFlag = ({ children, flag, fallback }: FeatureFlagProps): JSX.Element => {
  const { user } = useLoggedInUser()
  const queryKey = [`feature-flag-${flag}`]
  const userSpecialCase = user?.objeto?.[0]?.CodLogin?.toUpperCase() || ''
  const { data } = useQuery(queryKey, () => fetchFeatureFlag({ flag, specialCase: userSpecialCase }), {
    enabled: !!user
  })

  if (data === undefined) return <></>
  if (data.isActive) return children
  return fallback ?? <></>
}
